export default __webpack_public_path__ + "static/K_AI-e486f02d16fda169bd8bf5d5e8717fe7.webp";